/* Zorali in-house video carousel + shoppable player (replaces the Videowise app).
   No dependencies. Markup comes from snippets/zv-video-carousel.liquid; docs in
   OS/active/inhouse-apps-2026-10/video-build/README.md */
(function () {
  'use strict';
  if (window.__zvVideo) return;
  window.__zvVideo = true;

  var d = document;
  var CAROUSEL_MOBILE = window.matchMedia('(max-width: 768px)');
  var PLAYER_DESKTOP = window.matchMedia('(min-width: 1024px)');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------- icons (Videowise's own glyphs, so the player looks the same) ---------------- */
  var I = {
    close: '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true"><g style="filter:drop-shadow(0 0 5px rgba(0,0,0,.5)) drop-shadow(0 1px .5px rgba(0,0,0,.06))"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5297 10.4697C11.2368 10.1768 10.762 10.1768 10.4691 10.4697C10.1762 10.7626 10.1762 11.2374 10.4691 11.5303L20.9389 22.0001L10.4692 32.4698C10.1763 32.7627 10.1763 33.2376 10.4692 33.5305C10.7621 33.8234 11.2369 33.8234 11.5298 33.5305L21.9995 23.0608L32.4691 33.5303C32.762 33.8232 33.2368 33.8232 33.5297 33.5303C33.8226 33.2374 33.8226 32.7626 33.5297 32.4697L23.0602 22.0001L33.5298 11.5305C33.8227 11.2376 33.8227 10.7627 33.5298 10.4698C33.2369 10.1769 32.7621 10.1769 32.4692 10.4698L21.9995 20.9395L11.5297 10.4697Z" fill="#fff"/></g></svg>',
    sound: '<svg class="zv-ico-sound" width="28" height="26" viewBox="0 0 28 26" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 16.5001H5.64304C6.22014 16.5001 6.77947 16.6997 7.22613 17.0652L15.5 23.8347V2.16542L7.22613 8.93495C6.77948 9.30039 6.22014 9.50005 5.64304 9.50005H1.5V16.5001ZM5.64304 8.00005H1C0.447716 8.00005 0 8.44777 0 9.00005V17.0001C0 17.5523 0.447716 18.0001 1 18.0001H5.64304C5.87388 18.0001 6.09761 18.0799 6.27627 18.2261L15.3668 25.6638C16.0197 26.198 17 25.7334 17 24.8898V1.1103C17 0.266669 16.0197 -0.197879 15.3668 0.336337L6.27627 7.77401C6.09761 7.92019 5.87388 8.00005 5.64304 8.00005ZM24.6488 4.33732C25.0149 4.1434 25.4688 4.28292 25.6627 4.64894C27 7.17317 27.7187 10.0536 27.7499 12.9921L27.75 13.0001L27.7499 13.008C27.7187 15.9465 27 18.8269 25.6627 21.3512C25.4688 21.7172 25.0149 21.8567 24.6488 21.6628C24.2828 21.4689 24.1433 21.015 24.3372 20.6489C25.5575 18.3456 26.2199 15.7045 26.2499 13.0001C26.2199 10.2956 25.5575 7.65448 24.3372 5.35117C24.1433 4.98515 24.2828 4.53123 24.6488 4.33732ZM21.6382 8.60612C21.4206 8.25365 20.9585 8.14427 20.606 8.36184C20.2536 8.5794 20.1442 9.0415 20.3617 9.39398C20.9677 10.3757 21.2924 11.6527 21.2455 12.9735L21.2446 13.0001L21.2455 13.0266C21.2924 14.3474 20.9677 15.6244 20.3617 16.6061C20.1442 16.9586 20.2536 17.4207 20.606 17.6383C20.9585 17.8558 21.4206 17.7465 21.6382 17.394C22.4114 16.1412 22.7965 14.576 22.7455 13.0001C22.7965 11.4241 22.4114 9.85891 21.6382 8.60612Z" fill="#fff"/></svg>',
    muted: '<svg class="zv-ico-muted" width="28" height="26" viewBox="0 0 28 26" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 16.5001H5.64304C6.22014 16.5001 6.77947 16.6997 7.22613 17.0652L15.5 23.8347V2.16542L7.22613 8.93495C6.77948 9.30039 6.22014 9.50005 5.64304 9.50005H1.5V16.5001ZM5.64304 8.00005H1C0.447716 8.00005 0 8.44777 0 9.00005V17.0001C0 17.5523 0.447716 18.0001 1 18.0001H5.64304C5.87388 18.0001 6.09761 18.0799 6.27627 18.2261L15.3668 25.6638C16.0197 26.198 17 25.7334 17 24.8898V1.1103C17 0.266669 16.0197 -0.197879 15.3668 0.336337L6.27627 7.77401C6.09761 7.92019 5.87388 8.00005 5.64304 8.00005Z" fill="#fff"/><path d="M20.5 9.5L27 16M27 9.5L20.5 16" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>',
    share: '<svg width="28" height="27" viewBox="0 0 28 27" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.2293 1.53307C14.2293 0.685633 15.2173 0.222345 15.8688 0.76431L27.2487 10.2312C27.7292 10.6309 27.7294 11.3686 27.249 11.7685L15.8711 21.2411C15.2183 21.7845 14.2281 21.3182 14.2313 20.4688L14.2481 16.0037C14.1916 15.984 14.1298 15.9633 14.0628 15.9421C13.6501 15.8116 13.0445 15.6635 12.2934 15.603C10.7993 15.4826 8.7126 15.7065 6.39401 17.1381C3.54834 18.895 2.52374 21.0816 2.18437 22.8026C2.01256 23.6739 2.0146 24.4382 2.05926 24.982C2.08154 25.2533 2.11427 25.4677 2.14044 25.6105C2.16133 25.7244 2.09456 25.8369 1.98245 25.8663L1.13238 26.0889C0.913471 26.1462 0.687594 26.0117 0.64272 25.79C0.593027 25.5443 0.528311 25.1906 0.465797 24.7487C0.340907 23.8657 0.224041 22.6249 0.255052 21.1862C0.316872 18.3182 0.968305 14.6009 3.38394 11.38C5.67908 8.31982 8.58889 6.91857 10.9127 6.28515C12.0734 5.96878 13.0919 5.84253 13.8237 5.79538C13.9706 5.78591 14.1062 5.77962 14.2293 5.77563V1.53307ZM14.9242 7.27786L14.9159 7.27735C14.9069 7.27682 14.8918 7.276 14.8708 7.27508C14.8288 7.27325 14.7634 7.27105 14.6767 7.2701C14.5033 7.26821 14.2454 7.27132 13.9201 7.29228C13.2687 7.33425 12.3526 7.44743 11.3072 7.73236C9.219 8.30155 6.63116 9.55037 4.58394 12.28C2.85819 14.5811 2.12076 17.1944 1.86463 19.5254C2.6325 18.2481 3.81431 16.9679 5.60599 15.8617C8.23049 14.2413 10.6438 13.9653 12.4139 14.1079C13.295 14.1788 14.0125 14.353 14.515 14.5119C14.7665 14.5914 14.9649 14.6673 15.104 14.7252C15.1736 14.7541 15.2284 14.7786 15.2678 14.7967C15.2874 14.8058 15.3032 14.8133 15.315 14.8191L15.3298 14.8263L15.3349 14.8288L15.3369 14.8298C15.3369 14.8298 15.3385 14.8306 15 15.4999L15.3385 14.8306L15.7517 15.0396L15.7353 19.4023L25.8275 11.0001L15.7293 2.59941V7.33712L14.9257 7.27796L14.9242 7.27786Z" fill="#fff"/></svg>',
    play: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" style="filter:drop-shadow(0 1px 1px rgba(0,0,0,.2))"><path d="M5.15002 3.55542L16.7503 10L5.15002 16.4446V3.55542Z" fill="#fff"/></svg>',
    down: '<svg width="20" height="12" viewBox="0 0 20 12" fill="none" aria-hidden="true"><path d="M1.11089 1.55567L9.99978 10.4446L18.8887 1.55566" stroke="#fff" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/></svg>',
    up: '<svg width="20" height="12" viewBox="0 0 20 12" fill="none" aria-hidden="true"><path d="M1.11089 10.4443L9.99978 1.55542L18.8887 10.4443" stroke="#fff" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/></svg>',
    grid: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="2.75" y="2.75" width="7.5" height="7.5" rx="1.25" stroke="#000" stroke-width="1.5"/><rect x="2.75" y="13.75" width="7.5" height="7.5" rx="1.25" stroke="#000" stroke-width="1.5"/><rect x="13.75" y="2.75" width="7.5" height="7.5" rx="1.25" stroke="#000" stroke-width="1.5"/><rect x="13.75" y="13.75" width="7.5" height="7.5" rx="1.25" stroke="#000" stroke-width="1.5"/></svg>',
    back: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M11 4L2 12M2 12L11 20M2 12L22 12" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    check: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M15.5 6.5L8.5 13.5L4.5 9.5" stroke="#fff" stroke-width="2"/></svg>',
    chevron: '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M15 6L9 12L3 6" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    chevronDark: '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 18 18" fill="none"><path d="M15 6L9 12L3 6" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    plus: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 1v14M1 8h14" stroke="#000" stroke-width="1.5" stroke-linecap="round"/></svg>',
    minus: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 8h14" stroke="#000" stroke-width="1.5" stroke-linecap="round"/></svg>',
    cart: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1.125C1.08579 1.125 0.75 1.46079 0.75 1.875C0.75 2.28921 1.08579 2.625 1.5 2.625H3.15337L5.26921 11.7936C5.34774 12.1339 5.65076 12.375 6 12.375H14.25C14.5869 12.375 14.8825 12.1503 14.9726 11.8257L16.8476 5.07573C16.9104 4.84991 16.8639 4.60775 16.7221 4.42116C16.5803 4.23456 16.3594 4.125 16.125 4.125H5.03894L4.48079 1.70636C4.40226 1.36606 4.09924 1.125 3.75 1.125H1.5ZM6.59663 10.875L5.3851 5.625H15.1383L13.6799 10.875H6.59663ZM7.5 16.5C8.32843 16.5 9 15.8284 9 15C9 14.1716 8.32843 13.5 7.5 13.5C6.67157 13.5 6 14.1716 6 15C6 15.8284 6.67157 16.5 7.5 16.5ZM15 15C15 15.8284 14.3284 16.5 13.5 16.5C12.6716 16.5 12 15.8284 12 15C12 14.1716 12.6716 13.5 13.5 13.5C14.3284 13.5 15 14.1716 15 15Z" fill="#fff"/></svg>',
    arrowR: '<svg width="24" height="24" viewBox="0 0 32 32" fill="none" aria-hidden="true"><circle cx="16" cy="16" r="16" fill="#fff"/><path d="M13.5 8.5L21 16L13.5 23.5" stroke="#121212" stroke-width="2" stroke-linecap="square"/></svg>',
    arrowL: '<svg width="24" height="24" viewBox="0 0 32 32" fill="none" aria-hidden="true"><circle cx="16" cy="16" r="16" fill="#fff"/><path d="M18.5 8.5L11 16L18.5 23.5" stroke="#121212" stroke-width="2" stroke-linecap="square"/></svg>',
    swipe: '<svg width="57" height="49" viewBox="0 0 57 49" fill="none" aria-hidden="true"><path style="filter:drop-shadow(0 0 5px rgba(0,0,0,.5))" d="M20.9246 19.943L15.2678 14.2861C14.2915 13.3098 12.7085 13.3098 11.7322 14.2861C10.7559 15.2624 10.7559 16.8453 11.7322 17.8216L25.5208 31.6102L19.7971 32.0872C18.2989 32.212 17.2148 33.5723 17.4274 35.0606C17.609 36.3317 18.6873 37.2826 19.9712 37.3036L33.3102 37.5223C37.1446 37.5851 40.8404 36.0897 43.552 33.378L44.3056 32.6245C45.6263 31.3037 46.3244 29.4845 46.2262 27.6193C46.0979 25.1811 45.0716 22.8768 43.3452 21.1504L33.3885 11.1936C33.33 11.1351 33.2562 11.0943 33.1756 11.0757C31.1098 10.5989 29.2582 12.4504 29.735 14.5163L29.7635 14.6397M20.9246 19.943L26.2279 25.2463M20.9246 19.943L20.8297 19.4685C20.4108 17.374 22.4666 15.6407 24.4602 16.4074M24.4602 16.4074L29.7635 21.7107M24.4602 16.4074L24.3871 16.0908C23.9309 14.1142 25.7025 12.3427 27.6791 12.7988C27.886 12.8466 28.0753 12.9515 28.2254 13.1016L29.7635 14.6397M29.7635 14.6397L33.299 18.1752" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---------------- helpers ---------------- */
  function el(tag, cls, html) { var e = d.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(name, detail) {
    detail = detail || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, detail)); } catch (e) {}
    try { d.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    var v = cents / 100;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + v.toFixed(v % 1 ? 2 : 0); }
  }
  function img(src, w) {
    if (!src) return '';
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return src.replace(/([?&])width=\d+&?/, '$1') + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    return src;
  }
  var productCache = {};
  function getProduct(handle) {
    if (!handle) return Promise.reject(new Error('no handle'));
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (e) { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }
  function pageVariantId() {
    var f = d.querySelector('form[action*="/cart/add"] [name="id"]');
    return f && f.value ? +f.value : null;
  }

  /* ---------------- carousel ---------------- */
  function initCarousel(c) {
    if (c.__zv) return;
    var dataEl = c.querySelector('[data-zv-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    c.__zv = data;
    if (c.hasAttribute('data-zv-dark')) {
      if (!d.documentElement.classList.contains('zv-on')) return;
      c.removeAttribute('hidden');
      var sec = c.closest('[data-zv-section]');
      if (sec) sec.removeAttribute('hidden');
    }
    // open player (carousel cards and gallery tiles)
    c.addEventListener('click', function (e) {
      var card = e.target.closest('[data-zv-open]');
      if (!card || (c.__zvMoved && c.__zvMoved())) return;
      Player.open(data, +card.getAttribute('data-zv-open'), c);
    });
    c.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-zv-open]')) { e.preventDefault(); Player.open(data, +e.target.getAttribute('data-zv-open'), c); }
    });
    if (!c.__zvViewTracked) { c.__zvViewTracked = true; track('zv_video_view', { product: data.product, videos: data.videos.length }); }
    var vp = c.querySelector('[data-zv-viewport]');
    if (!vp) return; // masonry gallery: no scrolling row, no preview loops (Videowise has thumbnail autoplay off there)
    var prev = c.querySelector('[data-zv-prev]');
    var next = c.querySelector('[data-zv-next]');
    var slides = [].slice.call(c.querySelectorAll('.zv-carousel__slide'));

    function layout() {
      var m = slides[0] && slides[0].querySelector('.zv-card__media');
      if (m) c.style.setProperty('--zv-arrow-top', m.offsetHeight / 2 + 'px');
      c.classList.remove('zv-is-centered');
      var overflow = vp.scrollWidth - vp.clientWidth > 1;
      // Videowise centres the row when every card fits (2- and 3-video playlists).
      c.classList.toggle('zv-is-centered', !overflow);
      [prev, next].forEach(function (b) { if (b) b.classList.toggle('zv-is-hidden', !overflow); });
      state();
    }
    function state() {
      var max = vp.scrollWidth - vp.clientWidth;
      if (prev) prev.disabled = vp.scrollLeft <= 1;
      if (next) next.disabled = vp.scrollLeft >= max - 1;
    }
    function step(dir) {
      var s = slides[0]; if (!s) return;
      var gap = parseFloat(getComputedStyle(s.parentNode).columnGap || getComputedStyle(s.parentNode).gap) || 0;
      vp.scrollBy({ left: dir * (s.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    vp.addEventListener('scroll', state, { passive: true });
    window.addEventListener('resize', layout);
    layout();

    // mouse drag (touch scrolls natively)
    var drag = null, moved = false;
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: vp.scrollLeft }; moved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!moved && Math.abs(dx) > 5) { moved = true; vp.classList.add('zv-is-dragging'); }
      if (moved) vp.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      drag = null;
      if (moved) {
        vp.classList.remove('zv-is-dragging');
        var s = slides[0], w = s ? s.getBoundingClientRect().width + (parseFloat(getComputedStyle(s.parentNode).gap) || 0) : 1;
        vp.scrollTo({ left: Math.round(vp.scrollLeft / w) * w, behavior: 'smooth' });
        setTimeout(function () { moved = false; }, 0);
      }
    });

    c.__zvMoved = function () { return moved; };

    // previews: play the 3 s clip only while the card is on screen and the tab is visible
    var vids = [].slice.call(c.querySelectorAll('.zv-card__preview'));
    var visible = new Set();
    function play(v) {
      if (d.hidden || Player.isOpen()) return;
      if (!v.getAttribute('src')) { v.src = v.getAttribute('data-zv-src'); v.preload = 'auto'; }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { visible.add(en.target); play(en.target); }
          else { visible.delete(en.target); en.target.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    } else vids.forEach(play);
    c.__zvResume = function () { visible.forEach(play); };
    c.__zvPause = function () { vids.forEach(function (v) { v.pause(); }); };
    d.addEventListener('visibilitychange', function () { if (d.hidden) c.__zvPause(); else c.__zvResume(); });

  }

  /* ---------------- player ---------------- */
  var Player = (function () {
    var p = null, data = null, idx = 0, host = null, muted = false, panel = null, wheelLock = 0, lastFocus = null;
    function isOpen() { return !!p; }

    function open(dt, i, carousel) {
      if (p) close();
      data = dt; idx = i || 0; host = carousel; muted = false; lastFocus = d.activeElement;
      if (host && host.__zvPause) host.__zvPause();
      build();
      d.documentElement.classList.add('zv-player-open');
      go(idx, true);
      track('zv_video_play', { product: data.product, video: data.videos[idx] && data.videos[idx].id, title: data.videos[idx] && data.videos[idx].title });
    }

    function loadInter() {
      // Videowise's player UI is set in Inter; load it only when the player first opens.
      if (d.getElementById('zv-inter')) return;
      var l = d.createElement('link'); l.id = 'zv-inter'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Inter:opsz@14..32&display=swap';
      d.head.appendChild(l);
    }

    function build() {
      loadInter();
      p = el('div', 'zv-player');
      p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true'); p.setAttribute('aria-label', 'Video player');
      var n = data.videos.length;
      var desktop = PLAYER_DESKTOP.matches;
      var html = '<div class="zv-player__stage"><div class="zv-player__gradient"></div><div class="zv-player__slides">';
      data.videos.forEach(function (v, k) {
        if (v.type === 'image') { html += '<div class="zv-player__slide zv-player__slide--image" aria-hidden="' + (k === idx ? 'false' : 'true') + '"><img class="zv-player__image" src="' + esc(img(v.poster, 1600)) + '" alt="' + esc(v.title) + '" loading="' + (Math.abs(k - idx) <= 1 ? 'eager' : 'lazy') + '"></div>'; return; }
        html += '<div class="zv-player__slide" aria-hidden="' + (k === idx ? 'false' : 'true') + '"><video class="zv-player__video" playsinline webkit-playsinline disablepictureinpicture disableremoteplayback preload="none" poster="' + esc(img(v.poster, 1080)) + '" data-src="' + esc(desktop ? v.video : (v.videoMobile || v.video)) + '"></video></div>';
      });
      html += '</div><div class="zv-player__click" aria-hidden="true"></div>';
      html += '<button type="button" class="zv-player__btn zv-player__close" aria-label="Close the video player">' + I.close + '</button>';
      if (data.logo) html += '<div class="zv-player__logo"><img src="' + esc(data.logo) + '" alt="Zorali"></div>';
      html += '<div class="zv-player__actions"><button type="button" class="zv-player__btn zv-player__mute" aria-label="Mute video" aria-pressed="false">' + I.sound + I.muted + '</button>';
      html += '<button type="button" class="zv-player__btn zv-player__share" aria-label="Share video">' + I.share + '</button></div>';
      if (n > 1) {
        html += '<div class="zv-player__nav"><button type="button" class="zv-player__btn zv-player__nav-btn zv-player__nav-btn--prev" aria-label="Display previous video">' + I.up + '</button>';
        html += '<div class="zv-player__boxes-wrap' + (n === 2 ? ' zv-player__boxes-wrap--two' : '') + '"><div class="zv-player__boxes">';
        data.videos.forEach(function (v, k) { html += '<button type="button" class="zv-player__box" data-k="' + k + '" aria-label="Display video ' + (k + 1) + ' out of ' + n + '"><img src="' + esc(img(v.poster, 200)) + '" alt="" loading="lazy"></button>'; });
        html += '</div></div><button type="button" class="zv-player__btn zv-player__nav-btn zv-player__nav-btn--next" aria-label="Display next video">' + I.down + '</button></div>';
        html += '<div class="zv-player__swipe" aria-hidden="true"><span class="zv-player__swipe-icon">' + I.swipe + '</span><span class="zv-player__swipe-text">Swipe up for next video</span></div>';
      }
      html += '<div class="zv-player__progress"><div class="zv-player__track"><div class="zv-player__fill"></div><div class="zv-player__knob"></div></div></div>';
      html += '<button type="button" class="zv-player__playbtn" aria-label="Play video">' + I.play + '</button>';
      html += '<button type="button" class="zv-player__unmute">Tap to unmute</button>';
      html += '<div class="zv-player__strip"><button type="button" class="zv-player__toggle" aria-label="Hide products">' + I.chevron + '</button><button type="button" class="zv-player__trigger"><span>Shop items</span></button><div class="zv-player__cards"></div></div>';
      html += '<div class="zv-player__toast" role="status">' + I.check + '<p style="margin:0"></p></div>';
      html += '</div>';
      p.innerHTML = html;
      panel = el('aside', 'zv-panel');
      panel.innerHTML = '<div class="zv-panel__view zv-panel__view--list"><div class="zv-panel__head"><button type="button" class="zv-panel__back" aria-label="Close products">' + I.back + '</button><p class="zv-panel__head-title">Products in video</p></div><ul class="zv-panel__list"></ul></div><div class="zv-panel__view zv-panel__view--detail" hidden></div>';
      if (desktop) p.appendChild(panel); else p.querySelector('.zv-player__stage').appendChild(panel);
      d.body.appendChild(p);
      bind();
      setTimeout(function () { var c = p && p.querySelector('.zv-player__close'); if (c) c.focus({ preventScroll: true }); }, 50);
    }

    // one entry per slide (null for photo slides), so indexes line up with data.videos
    function videos() { return p ? [].map.call(p.querySelectorAll('.zv-player__slide'), function (sl) { return sl.querySelector('video'); }) : []; }

    function go(k, first) {
      var n = data.videos.length;
      if (k < 0 || k >= n || (!first && k === idx)) return;
      var vs = videos();
      if (vs[idx] && !first) { vs[idx].pause(); }
      idx = k;
      p.querySelector('.zv-player__slides').style.transform = 'translate3d(0,' + (-100 * idx) + '%,0)';
      [].forEach.call(p.querySelectorAll('.zv-player__slide'), function (sl, j) { sl.setAttribute('aria-hidden', j === idx ? 'false' : 'true'); });
      vs.forEach(function (v, j) {
        if (!v) return;
        var near = Math.abs(j - idx) <= 1;
        if ((j === idx || near) && !v.getAttribute('src')) v.src = v.getAttribute('data-src');
        v.preload = j === idx ? 'auto' : (near ? 'metadata' : 'none');
        if (j !== idx) { v.pause(); try { v.currentTime = 0; } catch (e) {} }
      });
      var v = vs[idx];
      p.classList.toggle('zv-is-photo', !v);
      if (v) { v.muted = muted; playCurrent(); } else p.classList.remove('zv-is-paused');
      updateNav();
      renderProducts();
      if (!first) track('zv_video_play', { product: data.product, video: data.videos[idx].id, title: data.videos[idx].title });
    }

    function playCurrent() {
      var v = videos()[idx]; if (!v) return;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {
        if (!v.muted) { v.muted = true; setMuted(true, true); var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () { p.classList.add('zv-is-paused'); }); }
        else p.classList.add('zv-is-paused');
      });
    }

    function setMuted(m, auto) {
      muted = m;
      videos().forEach(function (v) { if (v) v.muted = m; });
      p.classList.toggle('zv-is-muted', m);
      p.classList.toggle('zv-needs-unmute', !!(m && auto));
      var b = p.querySelector('.zv-player__mute');
      b.setAttribute('aria-pressed', m ? 'false' : 'true');
      b.setAttribute('aria-label', m ? 'Unmute video' : 'Mute video');
    }

    function updateNav() {
      if (!p) return;
      var n = data.videos.length;
      var prev = p.querySelector('.zv-player__nav-btn--prev'), nxt = p.querySelector('.zv-player__nav-btn--next');
      if (prev) prev.classList.toggle('zv-is-hidden', idx === 0);
      if (nxt) nxt.classList.toggle('zv-is-hidden', idx === n - 1);
      [].forEach.call(p.querySelectorAll('.zv-player__box'), function (b, k) { b.classList.toggle('zv-is-active', k === idx); });
      var boxes = p.querySelector('.zv-player__boxes');
      if (boxes) { var visibleN = n === 2 ? 2 : 3; var off = Math.max(0, Math.min(idx - 1, n - visibleN)); boxes.style.top = (-100 * off) + 'px'; }
    }

    function bind() {
      var stage = p.querySelector('.zv-player__stage');
      p.querySelector('.zv-player__close').addEventListener('click', close);
      p.querySelector('.zv-player__mute').addEventListener('click', function () { setMuted(!muted); if (!muted) playCurrent(); });
      p.querySelector('.zv-player__unmute').addEventListener('click', function () { setMuted(false); playCurrent(); });
      p.querySelector('.zv-player__share').addEventListener('click', share);
      p.querySelector('.zv-player__playbtn').addEventListener('click', function () { p.classList.remove('zv-is-paused'); playCurrent(); });
      p.querySelector('.zv-player__click').addEventListener('click', function () {
        var v = videos()[idx]; if (!v) return;
        if (v.paused) { p.classList.remove('zv-is-paused'); playCurrent(); } else { v.pause(); p.classList.add('zv-is-paused'); }
      });
      var prev = p.querySelector('.zv-player__nav-btn--prev'), nxt = p.querySelector('.zv-player__nav-btn--next');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (nxt) nxt.addEventListener('click', function () { go(idx + 1); });
      [].forEach.call(p.querySelectorAll('.zv-player__box'), function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-k')); }); });
      videos().forEach(function (v, k) {
        if (!v) return;
        v.addEventListener('timeupdate', function () { if (k === idx) progress(v); });
        v.addEventListener('play', function () { if (k === idx) p.classList.remove('zv-is-paused'); });
        v.addEventListener('ended', function () { if (k === idx) { v.currentTime = 0; playCurrent(); } });
      });
      var prog = p.querySelector('.zv-player__progress');
      function seek(e) { var v = videos()[idx]; if (!v || !v.duration) return; var r = prog.getBoundingClientRect(); v.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * v.duration; progress(v); }
      prog.addEventListener('pointerdown', function (e) { seek(e); prog.setPointerCapture(e.pointerId); prog.onpointermove = seek; });
      prog.addEventListener('pointerup', function () { prog.onpointermove = null; });
      stage.addEventListener('wheel', function (e) {
        if (e.target.closest('.zv-panel')) return;
        e.preventDefault();
        var now = Date.now(); if (now - wheelLock < 700 || Math.abs(e.deltaY) < 12) return;
        wheelLock = now; go(idx + (e.deltaY > 0 ? 1 : -1));
      }, { passive: false });
      var ty = null, tt = 0;
      stage.addEventListener('touchstart', function (e) { if (e.target.closest('.zv-panel, .zv-player__cards')) { ty = null; return; } ty = e.touches[0].clientY; tt = Date.now(); }, { passive: true });
      stage.addEventListener('touchmove', function (e) { if (ty !== null) e.preventDefault(); }, { passive: false });
      stage.addEventListener('touchend', function (e) {
        if (ty === null) return;
        var dy = e.changedTouches[0].clientY - ty; ty = null;
        if (Math.abs(dy) > 50 || (Math.abs(dy) > 20 && Date.now() - tt < 250)) go(idx + (dy < 0 ? 1 : -1));
      });
      p.querySelector('.zv-player__toggle').addEventListener('click', function () { p.querySelector('.zv-player__strip').classList.toggle('zv-is-collapsed'); });
      p.querySelector('.zv-player__trigger').addEventListener('click', function () { openPanel('list'); });
      panel.querySelector('.zv-panel__back').addEventListener('click', closePanel);
      d.addEventListener('keydown', onKey, true);
      PLAYER_DESKTOP.addEventListener && PLAYER_DESKTOP.addEventListener('change', relayout);
    }

    function relayout() { if (!p) return; var k = idx; var dt = data; var h = host; close(); open(dt, k, h); }

    function onKey(e) {
      if (!p) return;
      if (e.key === 'Escape') { e.preventDefault(); if (!PLAYER_DESKTOP.matches && panel.classList.contains('zv-is-open')) closePanel(); else close(); }
      else if (e.key === 'ArrowDown' && !e.target.matches('select, input')) { e.preventDefault(); go(idx + 1); }
      else if (e.key === 'ArrowUp' && !e.target.matches('select, input')) { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'Tab') {
        var f = [].filter.call(p.querySelectorAll('button, [href], select, input, [tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null && !x.disabled; });
        if (!f.length) return;
        if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    }

    function progress(v) {
      if (!p) return;
      var pct = v.duration ? (v.currentTime / v.duration) * 100 : 0;
      p.querySelector('.zv-player__fill').style.width = pct + '%';
      p.querySelector('.zv-player__knob').style.left = pct + '%';
    }

    function share() {
      var url = location.href.split('#')[0];
      var v = data.videos[idx];
      if (navigator.share) { navigator.share({ title: v.title || d.title, url: url }).catch(function () {}); return; }
      var done = function () { toast('Copied link'); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {}); else done();
    }

    function toast(msg) {
      if (!p) return;
      var t = p.querySelector('.zv-player__toast');
      t.querySelector('p').textContent = msg;
      t.classList.add('zv-is-shown');
      clearTimeout(t.__t); t.__t = setTimeout(function () { t.classList.remove('zv-is-shown'); }, 3000);
    }

    function close() {
      if (!p) return;
      d.removeEventListener('keydown', onKey, true);
      PLAYER_DESKTOP.removeEventListener && PLAYER_DESKTOP.removeEventListener('change', relayout);
      videos().forEach(function (v) { if (v) { v.pause(); v.removeAttribute('src'); v.load(); } });
      p.remove(); p = null; panel = null;
      d.documentElement.classList.remove('zv-player-open');
      if (host && host.__zvResume) host.__zvResume();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    /* ----- products ----- */
    function handles() {
      // Only tagged products are shoppable, as with Videowise: an untagged video plays with no product panel.
      var v = data.videos[idx];
      return (v && v.products) || [];
    }

    function renderProducts() {
      var hs = handles(), token = {};
      renderProducts.token = token;
      var list = panel.querySelector('.zv-panel__list');
      var cards = p.querySelector('.zv-player__cards');
      list.innerHTML = ''; cards.innerHTML = '';
      showView('list');
      p.classList.toggle('zv-has-products', hs.length > 0);
      if (!hs.length) { closePanel(); return; }
      // Each entry is a handle or { handle, title, image }. A tagged product that no longer resolves
      // (unpublished) still lists from its stored title/image and shows as sold out, as Videowise does.
      Promise.all(hs.map(function (t) {
        var h = typeof t === 'string' ? t : t.handle;
        return getProduct(h).catch(function () {
          if (typeof t === 'string' || !t.title) return null;
          return { handle: h, id: null, title: t.title, featured_image: t.image, images: t.image ? [t.image] : [], available: false, price: 0, compare_at_price: null, options: [], variants: [{ id: null, title: 'Default Title', available: false, price: 0, options: [] }], description: '' };
        });
      })).then(function (prods) {
        if (renderProducts.token !== token || !p) return;
        prods = prods.filter(Boolean);
        prods.forEach(function (pr) {
          list.appendChild(itemEl(pr));
          var c = el('div', 'zv-pcard');
          c.innerHTML = '<div class="zv-pcard__img"><img src="' + esc(img(pr.featured_image, 160)) + '" alt=""></div><div class="zv-pcard__body"><div class="zv-pcard__title">' + esc(pr.title) + '</div><div class="zv-pcard__price">' + (pr.available ? money(pr.price) : '') + '</div></div><button type="button" class="zv-pcard__add" aria-label="Shop now: ' + esc(pr.title) + '">' + I.plus + '</button>';
          c.addEventListener('click', function () { openPanel('detail', pr); });
          cards.appendChild(c);
        });
        p.classList.toggle('zv-has-products', prods.length > 0);
      });
    }

    function itemEl(pr) {
      var li = el('li', 'zv-item');
      var price = pr.available ? money(pr.price) : '';
      var cmp = pr.available && pr.compare_at_price > pr.price ? '<s>' + money(pr.compare_at_price) + '</s>' : '';
      li.innerHTML = '<div class="zv-item__pic"><img src="' + esc(img(pr.featured_image, 400)) + '" alt="" loading="lazy">' + (cmp ? '<span class="zv-item__sale">Sale</span>' : '') + '</div>' +
        '<div class="zv-item__details"><div class="zv-item__title">' + esc(pr.title) + '</div><div class="zv-item__price"><p>' + (price ? '<span class="zv-sr" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Price: </span>' + price : '') + cmp + '</p></div>' +
        '<button type="button" class="zv-item__shop" aria-label="Shop now: ' + esc(pr.title) + '">Shop now</button></div>';
      li.addEventListener('click', function () { showDetail(pr); });
      return li;
    }

    function openPanel(view, pr) {
      if (view === 'detail' && pr) showDetail(pr); else showView('list');
      panel.classList.add('zv-is-open');
    }
    function closePanel() { panel.classList.remove('zv-is-open'); }
    function showView(v) {
      var list = panel.querySelector('.zv-panel__view--list'), det = panel.querySelector('.zv-panel__view--detail');
      list.hidden = v !== 'list'; det.hidden = v !== 'detail';
    }

    function showDetail(pr) {
      var det = panel.querySelector('.zv-panel__view--detail');
      var pre = pr.handle === data.product ? pageVariantId() : null;
      var variant = pr.variants.filter(function (x) { return x.id === pre; })[0] || pr.variants.filter(function (x) { return x.available; })[0] || pr.variants[0];
      var qty = 1;
      var hasOptions = !(pr.variants.length === 1 && /default/i.test(pr.variants[0].title));
      var imgs = (pr.images || []).slice(0, 12);
      var html = '<div class="zv-detail__head"><button type="button" class="zv-detail__all">' + I.grid + '<span>All products</span></button></div><div class="zv-detail__scroll">';
      html += '<div class="zv-detail__media"><div class="zv-detail__media-bar">' + imgs.map(function (s) { return '<img src="' + esc(img(s, 400)) + '" alt="">'; }).join('') + '</div>';
      if (imgs.length > 1) html += '<button type="button" class="zv-detail__media-arrow zv-detail__media-arrow--left" aria-label="Previous image" hidden>' + I.arrowL + '</button><button type="button" class="zv-detail__media-arrow zv-detail__media-arrow--right" aria-label="Next image">' + I.arrowR + '</button>';
      html += '</div><div class="zv-detail__content"><h2 class="zv-detail__title">' + esc(pr.title) + '</h2><div class="zv-detail__price-wrap"><span class="zv-detail__price"></span><span class="zv-detail__compare"></span><span class="zv-detail__stock"></span></div>';
      if (hasOptions) {
        html += '<div class="zv-detail__options">' + pr.options.map(function (o, k) {
          return '<div class="zv-detail__option"><label for="zv-opt-' + k + '">' + esc(o.name) + '</label><select id="zv-opt-' + k + '" data-k="' + k + '">' + o.values.map(function (val) { return '<option value="' + esc(val) + '">' + esc(val) + '</option>'; }).join('') + '</select></div>';
        }).join('') + '</div>';
      }
      html += '<div class="zv-detail__buy"><div class="zv-qty"><button type="button" aria-label="Decrease quantity" data-q="-1">' + I.minus + '</button><span>1</span><button type="button" aria-label="Increase quantity" data-q="1">' + I.plus + '</button></div><button type="button" class="zv-atc">' + I.cart + '<span>Add to cart</span></button></div></div>';
      if (pr.description) html += '<details class="zv-detail__acc"><summary>Details' + I.chevronDark + '</summary><div class="zv-detail__acc-body">' + pr.description + '</div></details>';
      html += '<div class="zv-detail__rec" hidden><p class="zv-detail__rec-title">Recommended products</p><ul class="zv-panel__list"></ul></div></div>';
      det.innerHTML = html;
      showView('detail');
      det.scrollTop = 0;

      var bar = det.querySelector('.zv-detail__media-bar'), al = det.querySelector('.zv-detail__media-arrow--left'), ar = det.querySelector('.zv-detail__media-arrow--right');
      function arrows() { if (!al) return; al.hidden = bar.scrollLeft <= 1; ar.hidden = bar.scrollLeft >= bar.scrollWidth - bar.clientWidth - 1; }
      if (al) { al.addEventListener('click', function () { bar.scrollBy({ left: -200 }); }); ar.addEventListener('click', function () { bar.scrollBy({ left: 200 }); }); bar.addEventListener('scroll', arrows, { passive: true }); }

      var sels = [].slice.call(det.querySelectorAll('select'));
      function setVariant(v) {
        variant = v;
        sels.forEach(function (s, k) { if (v && v.options[k] != null) s.value = v.options[k]; });
        var pe = det.querySelector('.zv-detail__price'), ce = det.querySelector('.zv-detail__compare'), se = det.querySelector('.zv-detail__stock'), atc = det.querySelector('.zv-atc');
        pe.innerHTML = v ? '<span style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Price: </span>' + money(v.price) : '';
        ce.textContent = v && v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        var ok = v && v.available;
        if (hasOptions && v) { se.textContent = !v ? 'Not available' : ok ? 'In stock' : 'Out of stock'; se.classList.toggle('zv-is-out', !ok); } else se.textContent = '';
        atc.disabled = !ok;
        atc.querySelector('span').textContent = ok ? 'Add to cart' : (v ? 'Sold out' : 'Not available');
        atc.setAttribute('aria-label', atc.querySelector('span').textContent);
        if (v && v.featured_image && bar) { var src = img(v.featured_image.src, 400); [].forEach.call(bar.querySelectorAll('img'), function (im, k) { if (im.src.split('?')[0] === src.split('?')[0]) bar.scrollTo({ left: im.offsetLeft }); }); }
      }
      sels.forEach(function (s) {
        s.addEventListener('change', function () {
          var vals = sels.map(function (x) { return x.value; });
          setVariant(pr.variants.filter(function (v) { return v.options.every(function (o, k) { return o === vals[k]; }); })[0] || null);
        });
      });
      setVariant(variant);
      det.querySelector('.zv-qty').addEventListener('click', function (e) {
        var b = e.target.closest('[data-q]'); if (!b) return;
        qty = Math.max(1, qty + +b.getAttribute('data-q')); det.querySelector('.zv-qty span').textContent = qty;
      });
      det.querySelector('.zv-detail__all').addEventListener('click', function () { showView('list'); if (!PLAYER_DESKTOP.matches && handles().length < 2) closePanel(); });
      det.querySelector('.zv-atc').addEventListener('click', function () { if (variant && variant.available) addToCart(pr, variant, qty, this); });

      if (pr.id) fetch(root + 'recommendations/products.json?product_id=' + pr.id + '&limit=6&intent=related')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.products || !j.products.length || !p) return;
          var rec = det.querySelector('.zv-detail__rec'); if (!rec) return;
          var ul = rec.querySelector('.zv-panel__list');
          j.products.forEach(function (rp) { ul.appendChild(itemEl(rp)); });
          rec.hidden = false;
        }).catch(function () {});
    }

    function addToCart(pr, variant, qty, btn) {
      btn.classList.add('zv-is-loading'); btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          track('zv_video_add_to_cart', { product: pr.handle, variant: variant.id, quantity: qty, price: variant.price / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD', video: data.videos[idx] && data.videos[idx].id });
          toast(pr.title + ' was added to cart.');
          // Same as Videowise's "direct to cart" button: go straight to the cart page.
          setTimeout(function () { window.location.href = root + 'cart'; }, 400);
        })
        .catch(function (err) {
          btn.classList.remove('zv-is-loading'); btn.disabled = false;
          toast((err && (err.description || err.message)) || 'Could not add to cart');
        });
    }

    return { open: open, close: close, isOpen: isOpen };
  })();

  /* ---------------- boot ---------------- */
  function scan(rootEl) { [].forEach.call((rootEl || d).querySelectorAll('[data-zv-carousel]'), initCarousel); }
  scan();
  // zorali-pdp.js swaps the whole main section on colour change; pick up the new carousel.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) for (var j = 0; j < muts[i].addedNodes.length; j++) {
      var n = muts[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches('[data-zv-carousel]') || n.querySelector('[data-zv-carousel]'))) { scan(n.parentNode || d); return; }
    }
  }).observe(d.body || d.documentElement, { childList: true, subtree: true });
  if (CAROUSEL_MOBILE.addEventListener) CAROUSEL_MOBILE.addEventListener('change', function () { window.dispatchEvent(new Event('resize')); });
  window.ZoraliVideo = { open: function (carouselEl, i) { if (carouselEl && carouselEl.__zv) Player.open(carouselEl.__zv, i || 0, carouselEl); }, close: Player.close, scan: scan };
})();
